import { render, staticRenderFns } from "./Home4.vue?vue&type=template&id=9f67e754&scoped=true&"
import script from "./Home4.vue?vue&type=script&lang=js&"
export * from "./Home4.vue?vue&type=script&lang=js&"
import style0 from "./Home4.vue?vue&type=style&index=0&id=9f67e754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f67e754",
  null
  
)

export default component.exports